module.exports = __webpack_public_path__ + "img/person1.72e4a63e.svg";